/* import __COLOCATED_TEMPLATE__ from './custom-bots-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();